import React, { useEffect, useState } from 'react';
import { useShop } from '../contexts/ShopContext';
import { getShopContent } from '../api';
import ShopSidebarLeft from '../components/ShopSidebarLeft';
import { useLanguage } from '../i18n';

/** Mobile/tablet page for the owner's articles (the desktop shows them in the left sidebar). */
export default function ArticlesPage() {
  const { shop } = useShop();
  const { t } = useLanguage();
  const [articles, setArticles] = useState([]);
  const shopId = (shop && shop.id) || null;

  useEffect(() => {
    if (!shopId) return;
    getShopContent(shopId)
      .then((c) => setArticles(Array.isArray(c.articles) ? c.articles : []))
      .catch(() => setArticles([]));
  }, [shopId]);

  return (
    <div className="mx-auto max-w-3xl px-4 py-6">
      <h1 className="text-xl font-bold mb-4" style={{ color: 'var(--primary)' }}>{t('articles')}</h1>
      <ShopSidebarLeft articles={articles} />
    </div>
  );
}
